import React, { useRef, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { useEditor, useProcessIdsByValidationPassed } from '@Services/Editor';

import Layout from '@Templates/Layout';

import { LoadingLottie } from '@Components/Common/Lottie';

import Process from '@Components/Editor/Process';
// import AddingProcessButton from '@Components/Editor/AddingProcessButton';

const INITIAL_STATE = 0;

const COMPONENT_HEIGHT = {
  HEADER_MENU: 60,
  DIVIDER: 20,
};

const Main = ({
  isDataFetching,
  processRefs,
  addToProcessRefs,
  scrollToTargetProcess,
  snackBarRef,
  currentItems,
  setPage,
}) => {
  // const dispatch = useDispatch();
  const scrollRef = useRef(null);

  const { selectedProcessId, isUsingPageTabPress } = useSelector(useEditor);

  const processIdsByValidationPassed = useSelector(useProcessIdsByValidationPassed, shallowEqual);

  // const handleUpdateSelectedProcessId = useCallback(
  //   processId => {
  //     dispatch(setSelectedProcessId({ processId }));
  //   },
  //   [dispatch],
  // );

  const getIsFocusedProcess = element => {
    const { scrollTop } = scrollRef.current;
    const { height } = element.getBoundingClientRect();
    const { offsetTop } = element;

    const top = offsetTop - COMPONENT_HEIGHT.HEADER_MENU;
    const bottom = top + height - COMPONENT_HEIGHT.DIVIDER;

    return scrollTop < bottom;
  };

  const getFocusedProcessId = () => {
    const focusedProcess = processRefs.current.find(getIsFocusedProcess);
    return Number(focusedProcess.id);
  };

  const initializeScroll = () => {
    // handleUpdateSelectedProcessId(INITIAL_STATE);
    scrollToTargetProcess(INITIAL_STATE);
  };

  const handleScroll = () => {
    const focusedProcessId = getFocusedProcessId();
    const isNeedsDispatch = focusedProcessId !== selectedProcessId;

    if (isNeedsDispatch) {
      // handleUpdateSelectedProcessId(focusedProcessId);
    }
  };

  useEffect(() => {
    initializeScroll();
  }, []);

  useEffect(() => {
    if (!isUsingPageTabPress) {
      scrollRef.current.addEventListener('scroll', handleScroll);
    }

    return () => {
      const isRemoveEventListener = !isUsingPageTabPress && scrollRef && scrollRef.current;
      if (isRemoveEventListener) {
        scrollRef.current.removeEventListener('scroll', handleScroll);
      }
    };
  }, [scrollRef, isUsingPageTabPress]);

  // function getLocalStorageSize() {
  //   let totalSize = 0;

  //   for (const key in localStorage) {
  //     console.log('key:', key);
  //     if (localStorage.hasOwnProperty(key)) {
  //       totalSize += localStorage[key].length * 2; // 계산된 용량을 더합니다. 문자열은 2바이트로 가정합니다.
  //     }
  //   }

  //   // 용량을 메가바이트로 변환하여 반환합니다.
  //   return (totalSize / (1024 * 1024)).toFixed(2);
  // }

  // // 사용 예제
  // const localStorageSize = getLocalStorageSize();
  // console.log(`로컬 스토리지 사용 용량: ${localStorageSize} MB`);

  // console.log('offset:', offset);
  // console.log('limit:', limit);

  return (
    currentItems && (
      <Layout ref={scrollRef}>
        {isDataFetching ? (
          <LoadingLottieContainer>
            <LoadingLottie />
          </LoadingLottieContainer>
        ) : (
          <>
            {/* {posts.slice(offset, offset + limit).map(({ processId, text }) => (
            <article key={processId}>
              <h3>
                {processId}. {text}
              </h3>
            </article>
          ))} */}

            {currentItems?.map(
              ({ processId, text, isEventFinish, choices }) =>
                choices && (
                  <ProcessContainer key={processId} id={processId} ref={addToProcessRefs}>
                    <Process
                      processId={processId}
                      text={text}
                      isEventFinish={isEventFinish}
                      choices={choices}
                      processIdsByValidationPassed={processIdsByValidationPassed}
                      snackBarRef={snackBarRef}
                      scrollToTargetProcess={scrollToTargetProcess}
                      setPage={setPage}
                    />
                  </ProcessContainer>
                ),
            )}

            {/* {currentItems.map(({ processId, text, isEventFinish, choices }) => (
            <ProcessContainer key={processId} id={processId} ref={addToProcessRefs}>
              <Process
                processId={processId}
                text={text}
                isEventFinish={isEventFinish}
                choices={choices}
                processIdsByValidationPassed={processIdsByValidationPassed}
                snackBarRef={snackBarRef}
              />
            </ProcessContainer>
          ))} */}

            {/* <AddingProcessButton snackBarRef={snackBarRef} /> */}
          </>
        )}
      </Layout>
    )
  );
};

Main.propTypes = {
  isDataFetching: PropTypes.bool.isRequired,
  processRefs: PropTypes.objectOf(PropTypes.array).isRequired,
  addToProcessRefs: PropTypes.func.isRequired,
  scrollToTargetProcess: PropTypes.func.isRequired,
};

const ProcessContainer = styled.div``;

const LoadingLottieContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 100vh;
`;

export default Main;

// import React, { useRef, useEffect, useCallback } from 'react';
// import { useSelector, useDispatch, shallowEqual } from 'react-redux';
// import styled from 'styled-components';
// import PropTypes from 'prop-types';

// import { useEditor, useProcessIdsByValidationPassed, setSelectedProcessId } from '@Services/Editor';

// import Layout from '@Templates/Layout';

// import { LoadingLottie } from '@Components/Common/Lottie';

// import Process from '@Components/Editor/Process';
// // import AddingProcessButton from '@Components/Editor/AddingProcessButton';

// const INITIAL_STATE = 0;

// const COMPONENT_HEIGHT = {
//   HEADER_MENU: 60,
//   DIVIDER: 20,
// };

// const Main = ({
//   isDataFetching,
//   processRefs,
//   addToProcessRefs,
//   scrollToTargetProcess,
//   snackBarRef,
//   currentItems,
//   setPage,
// }) => {
//   const dispatch = useDispatch();
//   const scrollRef = useRef(null);

//   const { selectedProcessId, isUsingPageTabPress } = useSelector(useEditor);
//   const processIdsByValidationPassed = useSelector(useProcessIdsByValidationPassed, shallowEqual);

//   const handleUpdateSelectedProcessId = useCallback(
//     processId => {
//       dispatch(setSelectedProcessId({ processId }));
//     },
//     [dispatch],
//   );

//   const getIsFocusedProcess = element => {
//     const { scrollTop } = scrollRef.current;
//     const { height } = element.getBoundingClientRect();
//     const { offsetTop } = element;

//     const top = offsetTop - COMPONENT_HEIGHT.HEADER_MENU;
//     const bottom = top + height - COMPONENT_HEIGHT.DIVIDER;

//     return scrollTop < bottom;
//   };

//   const getFocusedProcessId = () => {
//     const focusedProcess = processRefs.current.find(getIsFocusedProcess);
//     return Number(focusedProcess.id);
//   };

//   const initializeScroll = () => {
//     handleUpdateSelectedProcessId(INITIAL_STATE);
//     scrollToTargetProcess(INITIAL_STATE);
//   };

//   const handleScroll = () => {
//     const focusedProcessId = getFocusedProcessId();
//     const isNeedsDispatch = focusedProcessId !== selectedProcessId;

//     if (isNeedsDispatch) {
//       handleUpdateSelectedProcessId(focusedProcessId);
//     }
//   };

//   useEffect(() => {
//     initializeScroll();
//   }, []);

//   useEffect(() => {
//     if (!isUsingPageTabPress) {
//       scrollRef.current.addEventListener('scroll', handleScroll);
//     }

//     return () => {
//       const isRemoveEventListener = !isUsingPageTabPress && scrollRef && scrollRef.current;
//       if (isRemoveEventListener) {
//         scrollRef.current.removeEventListener('scroll', handleScroll);
//       }
//     };
//   }, [scrollRef, isUsingPageTabPress]);

//   // function getLocalStorageSize() {
//   //   let totalSize = 0;

//   //   for (const key in localStorage) {
//   //     console.log('key:', key);
//   //     if (localStorage.hasOwnProperty(key)) {
//   //       totalSize += localStorage[key].length * 2; // 계산된 용량을 더합니다. 문자열은 2바이트로 가정합니다.
//   //     }
//   //   }

//   //   // 용량을 메가바이트로 변환하여 반환합니다.
//   //   return (totalSize / (1024 * 1024)).toFixed(2);
//   // }

//   // // 사용 예제
//   // const localStorageSize = getLocalStorageSize();
//   // console.log(`로컬 스토리지 사용 용량: ${localStorageSize} MB`);

//   // console.log('offset:', offset);
//   // console.log('limit:', limit);

//   return (
//     currentItems && (
//       <Layout ref={scrollRef}>
//         {isDataFetching ? (
//           <LoadingLottieContainer>
//             <LoadingLottie />
//           </LoadingLottieContainer>
//         ) : (
//           <>
//             {/* {posts.slice(offset, offset + limit).map(({ processId, text }) => (
//             <article key={processId}>
//               <h3>
//                 {processId}. {text}
//               </h3>
//             </article>
//           ))} */}

//             {currentItems?.map(
//               ({ processId, text, isEventFinish, choices }) =>
//                 choices && (
//                   <ProcessContainer key={processId} id={processId} ref={addToProcessRefs}>
//                     <Process
//                       processId={processId}
//                       text={text}
//                       isEventFinish={isEventFinish}
//                       choices={choices}
//                       processIdsByValidationPassed={processIdsByValidationPassed}
//                       snackBarRef={snackBarRef}
//                       scrollToTargetProcess={scrollToTargetProcess}
//                       setPage={setPage}
//                     />
//                   </ProcessContainer>
//                 ),
//             )}

//             {/* {currentItems.map(({ processId, text, isEventFinish, choices }) => (
//             <ProcessContainer key={processId} id={processId} ref={addToProcessRefs}>
//               <Process
//                 processId={processId}
//                 text={text}
//                 isEventFinish={isEventFinish}
//                 choices={choices}
//                 processIdsByValidationPassed={processIdsByValidationPassed}
//                 snackBarRef={snackBarRef}
//               />
//             </ProcessContainer>
//           ))} */}

//             {/* <AddingProcessButton snackBarRef={snackBarRef} /> */}
//           </>
//         )}
//       </Layout>
//     )
//   );
// };

// Main.propTypes = {
//   isDataFetching: PropTypes.bool.isRequired,
//   processRefs: PropTypes.objectOf(PropTypes.array).isRequired,
//   addToProcessRefs: PropTypes.func.isRequired,
//   scrollToTargetProcess: PropTypes.func.isRequired,
// };

// const ProcessContainer = styled.div``;

// const LoadingLottieContainer = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;

//   height: 100vh;
// `;

// export default Main;
